import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { searchProperties } from '../../common/properties/actions';
import { FilledButton, Exit } from '../app/components';
import { mapZipToDetailLocation, mapType, mapLocationToZips, uglifyLocation, prettifyLocation } from '../../common/app/helperFunctions';
import { MAX_SIZE, MAX_PRICE } from '../app/constants';
import TypeFilter from '../filters/TypeFilter/TypeFilter';
import PriceFilter from '../filters/PriceFilter/PriceFilter';
import SizeFilter from '../filters/SizeFilter/SizeFilter';
import BedroomsFilter from '../filters/BedroomsFilter/BedroomsFilter';
import ZipFilter from '../filters/ZipFilter/ZipFilter';
import './styles.css';

class PropertiesSearch extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    const { location } = this.props;
    const query = location.query;
    this.state = {
      displaySearch: false,
      activeLocation: 'areas',
      parent: '',
      subParent: '',
      // Search variables
      types: (query && query.types) ? (typeof query.types === 'string' ? [query.types] : query.types) : [],
      areas: (query && query.areas) ? (typeof query.areas === 'string' ? [query.areas] : query.areas) : [],
      towns: (query && query.towns) ? (typeof query.towns === 'string' ? [query.towns] : query.towns) : [],
      zips: (query && query.zips) ? (typeof query.zips === 'string' ? [query.zips] : query.zips) : [],
      minPrice: (query && query.minPrice) ? parseInt(query.minPrice, 10) : 0,
      maxPrice: (query && query.maxPrice) ? parseInt(query.maxPrice, 10) : MAX_PRICE,
      bedrooms: (query && query.bedrooms) ? parseInt(query.bedrooms, 10) : 0,
      minSize: (query && query.minSize) ? parseInt(query.minSize, 10) : 0,
      maxSize: (query && query.maxSize) ? parseInt(query.maxSize, 10) : MAX_SIZE,
      capitalCounter: (query && query.capitalCounter) ?
        parseInt(query.capitalCounter, 10) : 0,
      sudurnesCounter: (query && query.sudurnesCounter) ?
        parseInt(query.sudurnesCounter, 10) : 0,
      nordurlandCounter: (query && query.nordurlandCounter) ?
        parseInt(query.nordurlandCounter, 10) : 0,
      vestfirdirCounter: (query && query.vestfirdirCounter) ?
        parseInt(query.vestfirdirCounter, 10) : 0,
      vesturlandCounter: (query && query.vesturlandCounter) ?
        parseInt(query.vesturlandCounter, 10) : 0,
      austurlandCounter: (query && query.austurlandCounter) ?
        parseInt(query.austurlandCounter, 10) : 0,
      sudurlandCounter: (query && query.sudurlandCounter) ?
        parseInt(query.sudurlandCounter, 10) : 0,
      reykjavikCounter: (query && query.reykjavikCounter) ?
        parseInt(query.reykjavikCounter, 10) : 0,
      kopavogurCounter: (query && query.kopavogurCounter) ?
        parseInt(query.kopavogurCounter, 10) : 0,
      gardabaerCounter: (query && query.gardabaerCounter) ?
        parseInt(query.gardabaerCounter, 10) : 0,
      hfjCounter: (query && query.hfjCounter) ?
        parseInt(query.hfjCounter, 10) : 0,
      mosoCounter: (query && query.mosoCounter) ?
        parseInt(query.mosoCounter, 10) : 0,
      seltjarnanesCounter: (query && query.seltjarnanesCounter) ?
        parseInt(query.seltjarnanesCounter, 10) : 0,
    };
  }

  componentDidMount = () => {
    const { location } = this.props;
    if (location.query) { this.confirmSearch(); }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.displaySearch !== prevState.displaySearch) {
      if (this.state.displaySearch) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    }
  }

  onSelectArea = (e, area) => {
    const { areas } = this.state;
    e.preventDefault();
    areas.push(area);
    this.setState({ areas });
  }

  onDeSelectArea = (e, area) => {
    const { areas, towns } = this.state;
    e.preventDefault();
    const areaZips = mapLocationToZips(area);
    for (let i = 0; i < areaZips.length; i += 1) {
      this.state.zips = R.reject(z => z === areaZips[i], this.state.zips);
    }
    this.state.areas = R.reject(a => a === area, areas);

    if (area === 'capital') {
      const townLength = towns.length;
      for (let i = 0; i < townLength; i += 1) {
        this.onDeSelectTown(e, towns[0]);
      }
      this.state.towns = [];
    }
    const field = `${area}Counter`;
    this.state[field] = 0;
    this.setState(this.state);
  }

  onSelectTown = (e, town) => {
    const { towns } = this.state;
    e.preventDefault();
    towns.push(town);
    this.setState({
      towns,
      capitalCounter: this.state.capitalCounter + 1,
    });
  }

  onDeSelectTown = (e, town) => {
    const { towns } = this.state;
    e.preventDefault();
    const townZips = mapLocationToZips(town);
    for (let i = 0; i < townZips.length; i += 1) {
      this.state.zips = R.reject(z => z === townZips[i], this.state.zips);
    }
    this.state.towns = R.reject(t => t === town, towns);
    this.state.capitalCounter -= 1;
    const field = `${town}Counter`;
    this.state[field] = 0;
    this.setState(this.state);
  }

  onSelectZip = (e, zip, activeParent) => {
    const { zips } = this.state;
    e.preventDefault();
    zips.push(zip);
    this.state.zips = zips;
    const field = `${uglifyLocation(activeParent)}Counter`;
    this.state[field] = this.state[field] + 1;
    this.setState(this.state);
  }

  onDeselectZip = (e, zip, activeParent) => {
    const { zips } = this.state;
    e.preventDefault();
    this.state.zips = R.reject(z => z === zip, zips);
    const field = `${uglifyLocation(activeParent)}Counter`;
    this.state[field] = this.state[field] - 1;
    this.setState(this.state);
  }

  onSelectType = (e, type) => {
    const { types } = this.state;
    e.preventDefault();
    types.push(type);
    this.setState({ types });
  }

  onDeselectType = (e, type) => {
    const { types } = this.state;
    e.preventDefault();
    this.setState({ types: R.reject(t => t === type, types) });
  }

  onMinMaxPriceChange = (e) => {
    this.setState({ minPrice: e[0], maxPrice: e[1] });
  }

  onMinMaxSizeChange = (e) => {
    this.setState({ minSize: e[0], maxSize: e[1] });
  }

  onIncreaseBedrooms = (e) => {
    e.preventDefault();
    this.setState({ bedrooms: this.state.bedrooms + 1 });
  }

  onDecreaseBedrooms = (e) => {
    e.preventDefault();
    this.setState({ bedrooms: this.state.bedrooms - 1 });
  }

  setQueryParams = (e) => {
    const { location } = this.props;
    const {
      minPrice, maxPrice, minSize, maxSize, bedrooms,
      types, areas, towns, zips,
      capitalCounter, sudurnesCounter, nordurlandCounter, vestfirdirCounter,
      vesturlandCounter, austurlandCounter, sudurlandCounter, reykjavikCounter,
      kopavogurCounter, gardabaerCounter, hfjCounter, mosoCounter, seltjarnanesCounter,
    } = this.state;
    e.preventDefault();

    const query = {};
    if (minPrice !== 0) { query.minPrice = minPrice; }
    if (maxPrice !== MAX_PRICE) { query.maxPrice = maxPrice; }
    if (minSize !== 0) { query.minSize = minSize; }
    if (maxSize !== MAX_SIZE) { query.maxSize = maxSize; }
    if (bedrooms !== 0) { query.bedrooms = bedrooms; }
    if (!R.isEmpty(types)) { query.types = types; }
    if (!R.isEmpty(areas)) { query.areas = areas; }
    if (!R.isEmpty(towns)) { query.towns = towns; }
    if (!R.isEmpty(zips)) { query.zips = zips; }
    if (capitalCounter !== 0) { query.capitalCounter = capitalCounter; }
    if (sudurnesCounter !== 0) { query.sudurnesCounter = sudurnesCounter; }
    if (nordurlandCounter !== 0) { query.nordurlandCounter = nordurlandCounter; }
    if (vestfirdirCounter !== 0) { query.vestfirdirCounter = vestfirdirCounter; }
    if (vesturlandCounter !== 0) { query.vesturlandCounter = vesturlandCounter; }
    if (austurlandCounter !== 0) { query.austurlandCounter = austurlandCounter; }
    if (sudurlandCounter !== 0) { query.sudurlandCounter = sudurlandCounter; }
    if (reykjavikCounter !== 0) { query.reykjavikCounter = reykjavikCounter; }
    if (kopavogurCounter !== 0) { query.kopavogurCounter = kopavogurCounter; }
    if (gardabaerCounter !== 0) { query.gardabaerCounter = gardabaerCounter; }
    if (hfjCounter !== 0) { query.hfjCounter = hfjCounter; }
    if (mosoCounter !== 0) { query.mosoCounter = mosoCounter; }
    if (seltjarnanesCounter !== 0) { query.seltjarnanesCounter = seltjarnanesCounter; }

    this.context.router.transitionTo({
      pathname: '/',
      query,
      state: { from: (location && location.state && location.state.prevFrom) ? location.state.prevFrom : '/' },
    });
    this.confirmSearch();
  }

  getSearchString = () => {
    const {
      areas, towns, zips, types, minPrice, maxPrice, bedrooms, minSize, maxSize,
      capitalCounter, sudurnesCounter, nordurlandCounter,
      vestfirdirCounter, vesturlandCounter, austurlandCounter, reykjavikCounter,
      sudurlandCounter, kopavogurCounter, gardabaerCounter, hfjCounter, mosoCounter,
      seltjarnanesCounter,
    } = this.state;

    let newAreas = areas;
    if (R.contains('capital', newAreas) && capitalCounter !== 0) { newAreas = R.without(['capital'], newAreas); }
    if (R.contains('sudurnes', newAreas) && sudurnesCounter !== 0) { newAreas = R.without(['sudurnes'], newAreas); }
    if (R.contains('nordurland', newAreas) && nordurlandCounter !== 0) { newAreas = R.without(['nordurland'], newAreas); }
    if (R.contains('vestfirdir', newAreas) && vestfirdirCounter !== 0) { newAreas = R.without(['vestfirdir'], newAreas); }
    if (R.contains('vesturland', newAreas) && vesturlandCounter !== 0) { newAreas = R.without(['vesturland'], newAreas); }
    if (R.contains('austurland', newAreas) && austurlandCounter !== 0) { newAreas = R.without(['austurland'], newAreas); }
    if (R.contains('sudurland', newAreas) && sudurlandCounter !== 0) { newAreas = R.without(['sudurland'], newAreas); }

    let newTowns = towns;
    if (R.contains('reykjavik', newTowns) && reykjavikCounter !== 0) { newTowns = R.without(['reykjavik'], newTowns); }
    if (R.contains('kopavogur', newTowns) && kopavogurCounter !== 0) { newTowns = R.without(['kopavogur'], newTowns); }
    if (R.contains('gardabaer', newTowns) && gardabaerCounter !== 0) { newTowns = R.without(['gardabaer'], newTowns); }
    if (R.contains('hfj', newTowns) && hfjCounter !== 0) { newTowns = R.without(['hfj'], newTowns); }
    if (R.contains('moso', newTowns) && mosoCounter !== 0) { newTowns = R.without(['moso'], newTowns); }
    if (R.contains('seltjarnanes', newTowns) && seltjarnanesCounter !== 0) { newTowns = R.without(['seltjarnanes'], newTowns); }

    let searchTerms = newAreas.length + newTowns.length + zips.length + types.length;

    if (minPrice !== 0 || maxPrice < MAX_PRICE) { searchTerms += 1; }
    if (bedrooms > 0) { searchTerms += 1; }
    if (minSize !== 0 || maxSize < MAX_SIZE) { searchTerms += 1; }

    if (!searchTerms) {
      return 'Leitaðu hér!';
    } else if (searchTerms > 3) {
      return <span><span className="bold">{searchTerms}</span> leitarskilyrði</span>;
    }

    const priceString = () => {
      if (searchTerms > 1) {
        searchTerms -= 1;
        return <span><span className="bold">{minPrice / 1000}k</span> - <span className="bold">{maxPrice / 1000}k</span>{(maxPrice === MAX_PRICE && '+')} kr. <span className="search-seperator"> / </span></span>;
      }
      return <span><span className="bold">{minPrice / 1000}k</span> - <span className="bold">{maxPrice / 1000}k</span>{(maxPrice === MAX_PRICE && '+')} kr.</span>;
    };

    const bedroomsString = () => {
      if (searchTerms > 1) {
        searchTerms -= 1;
        return <span><span className="bold">{bedrooms}</span> svefnherb. <span className="search-seperator"> / </span></span>;
      }
      return <span><span className="bold">{bedrooms}</span> svefnherb.</span>;
    };

    const sizeString = () => {
      if (searchTerms > 1) {
        searchTerms -= 1;
        return <span><span className="bold">{minSize}</span> - <span className="bold">{maxSize}</span>{(maxSize === MAX_SIZE && '+')} fm. <span className="search-seperator"> / </span></span>;
      }
      return <span><span className="bold">{minSize}</span> - <span className="bold">{maxSize}</span>{(maxSize === MAX_SIZE && '+')} fm.</span>;
    };

    return (
      <span>
        {newAreas.length !== 0 &&
          newAreas.map((area) => {
            if (searchTerms > 1) {
              searchTerms -= 1;
              return <span>{prettifyLocation(area)} <span className="search-seperator"> / </span></span>;
            }
            return <span>{prettifyLocation(area)}</span>;
          })
        }
        {newTowns.length !== 0 &&
          newTowns.map((town) => {
            if (searchTerms > 1) {
              searchTerms -= 1;
              return <span>{prettifyLocation(town)} <span className="search-seperator"> / </span></span>;
            }
            return <span>{prettifyLocation(town)}</span>;
          })
        }
        {zips.length !== 0 &&
          zips.map((zip) => {
            if (searchTerms > 1) {
              searchTerms -= 1;
              return <span><span className="bold">{zip} </span>{mapZipToDetailLocation(zip)}<span className="search-seperator"> / </span></span>;
            }
            return <span><span className="bold">{zip} </span>{mapZipToDetailLocation(zip)}</span>;
          })
        }
        {types.length !== 0 &&
          types.map((type) => {
            if (searchTerms > 1) {
              searchTerms -= 1;
              return <span>{mapType(type)}<span className="search-seperator"> / </span></span>;
            }
            return <span>{mapType(type)}</span>;
          })
        }
        {(minPrice > 0 || maxPrice < MAX_PRICE) && priceString()}
        {(bedrooms > 0) && bedroomsString()}
        {(minSize > 0 || maxSize < MAX_SIZE) && sizeString()}
      </span>
    );
  }

  addZips = (zips, newZips) => {
    for (let i = 0; i < newZips.length; i += 1) { zips.push(newZips[i]); }
  }

  adjustZips = () => {
    const {
      zips, areas, towns, capitalCounter, sudurnesCounter, nordurlandCounter,
      vestfirdirCounter, vesturlandCounter, austurlandCounter, reykjavikCounter,
      sudurlandCounter, kopavogurCounter, gardabaerCounter, hfjCounter, mosoCounter,
      seltjarnanesCounter,
    } = this.state;

    const adjustedZips = [];
    for (let i = 0; i < zips.length; i += 1) { adjustedZips.push(zips[i]); }

    if (R.contains('capital', areas) && capitalCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('capital')); }
    if (R.contains('sudurnes', areas) && sudurnesCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('sudurnes')); }
    if (R.contains('nordurland', areas) && nordurlandCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('nordurland')); }
    if (R.contains('vestfirdir', areas) && vestfirdirCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('vestfirdir')); }
    if (R.contains('vesturland', areas) && vesturlandCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('vestfirdir')); }
    if (R.contains('austurland', areas) && austurlandCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('austurland')); }
    if (R.contains('sudurland', areas) && sudurlandCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('sudurland')); }

    if (R.contains('reykjavik', towns) && reykjavikCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('reykjavik')); }
    if (R.contains('kopavogur', towns) && kopavogurCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('kopavogur')); }
    if (R.contains('gardabaer', towns) && gardabaerCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('gardabaer')); }
    if (R.contains('hfj', towns) && hfjCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('hfj')); }
    if (R.contains('moso', towns) && mosoCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('moso')); }
    if (R.contains('seltjarnanes', towns) && seltjarnanesCounter === 0) { this.addZips(adjustedZips, mapLocationToZips('seltjarnanes')); }
    return adjustedZips;
  }

  toggleDisplaySearch = () => {
    this.setState({ displaySearch: !this.state.displaySearch });
  }

  changeActiveLocation = (e, location, parent, subParent) => {
    e.preventDefault();
    this.setState({
      activeLocation: location,
      parent: parent || '',
      subParent: subParent || '',
    });
  }

  confirmSearch = () => {
    const { searchProperties, propertiesPageNode } = this.props;
    const { types, minPrice, maxPrice, bedrooms, minSize, maxSize } = this.state;
    const adjustedZips = this.adjustZips();
    const searchVariables = {
      types, minPrice, maxPrice, bedrooms, minSize, maxSize, zips: adjustedZips,
    };
    searchProperties(searchVariables);

    this.setState({
      activeLocation: 'areas',
      parent: '',
      subParent: '',
      displaySearch: false,
    }, () => {
      if (propertiesPageNode) { propertiesPageNode.scrollIntoView(); }
    });
  }

  clearSearch = (e) => {
    e.preventDefault();
    this.setState({
      activeLocation: 'areas',
      parent: '',
      subParent: '',
      types: [],
      areas: [],
      towns: [],
      zips: [],
      minPrice: 0,
      maxPrice: MAX_PRICE,
      bedrooms: 0,
      minSize: 0,
      maxSize: MAX_SIZE,
      capitalCounter: 0,
      sudurnesCounter: 0,
      nordurlandCounter: 0,
      vestfirdirCounter: 0,
      vesturlandCounter: 0,
      austurlandCounter: 0,
      sudurlandCounter: 0,
      reykjavikCounter: 0,
      kopavogurCounter: 0,
      gardabaerCounter: 0,
      hfjCounter: 0,
      mosoCounter: 0,
      seltjarnanesCounter: 0,
    });
  }

  render() {
    const {
      displaySearch, activeLocation, parent, subParent, areas, towns, zips, types,
      capitalCounter, sudurnesCounter, nordurlandCounter, vestfirdirCounter,
      vesturlandCounter, austurlandCounter, sudurlandCounter, reykjavikCounter,
      kopavogurCounter, gardabaerCounter, hfjCounter, mosoCounter,
      seltjarnanesCounter,
      minPrice, maxPrice, minSize, maxSize, bedrooms,
    } = this.state;

    const { hasSearched } = this.props;

    return (
      <div className="properties-search">
        <button
          className={`search-bar${!displaySearch ? ' active' : ''}`}
          onClick={this.toggleDisplaySearch}
        >
          <span className="icon-search-icon" />
          <p>{hasSearched ? this.getSearchString() : 'Leitaðu hér!'}
          </p>
        </button>
        <div className={`property-search${displaySearch ? ' active' : ''}`}>
          <div className="header-wrapper">
            <Exit
              color="#222222"
              isLink={false}
              onClick={this.toggleDisplaySearch}
            />
            <h2>Leit</h2>
          </div>
          <div className="search-title">
            <span className="icon-search-icon" />
            <h1>Finndu draumaeignina</h1>
          </div>
          <div className="search-form">
            <div className="left-column">
              <ZipFilter
                activeLocation={activeLocation}
                parent={parent}
                subParent={subParent}
                areas={areas}
                towns={towns}
                zips={zips}
                capitalCounter={capitalCounter}
                sudurnesCounter={sudurnesCounter}
                nordurlandCounter={nordurlandCounter}
                austurlandCounter={austurlandCounter}
                vestfirdirCounter={vestfirdirCounter}
                vesturlandCounter={vesturlandCounter}
                sudurlandCounter={sudurlandCounter}
                reykjavikCounter={reykjavikCounter}
                kopavogurCounter={kopavogurCounter}
                hfjCounter={hfjCounter}
                gardabaerCounter={gardabaerCounter}
                mosoCounter={mosoCounter}
                seltjarnanesCounter={seltjarnanesCounter}
                changeActiveLocation={this.changeActiveLocation}
                onSelectArea={this.onSelectArea}
                onDeSelectArea={this.onDeSelectArea}
                onSelectTown={this.onSelectTown}
                onDeSelectTown={this.onDeSelectTown}
                onSelectZip={this.onSelectZip}
                onDeselectZip={this.onDeselectZip}
              />
            <TypeFilter
              types={types}
              onSelectType={this.onSelectType}
              onDeselectType={this.onDeselectType}
            />
            </div>
            <div className="right-column">
              <PriceFilter
                minPrice={minPrice}
                maxPrice={maxPrice}
                onMinMaxPriceChange={this.onMinMaxPriceChange}
              />
              <BedroomsFilter
                bedrooms={bedrooms}
                onIncreaseBedrooms={this.onIncreaseBedrooms}
                onDecreaseBedrooms={this.onDecreaseBedrooms}
              />
              <SizeFilter
                minSize={minSize}
                maxSize={maxSize}
                onMinMaxSizeChange={this.onMinMaxSizeChange}
              />
            </div>
          </div>
          <div className="button-wrapper">
            <FilledButton
              content={
                <p>Hreinsa</p>
              }
              className="no-icon"
              disabled={false}
              color="#222222"
              backgroundColor="#ffffff"
              onClick={this.clearSearch}
            />
            <FilledButton
              content={
                <div>
                  <span className="icon-search-icon" />
                  <p>Leita</p>
                </div>
              }
              color="#222222"
              backgroundColor="#00e39a"
              onClick={this.setQueryParams}
            />
          </div>
        </div>
      </div>
    );
  }
}

PropertiesSearch.propTypes = {
  location: React.PropTypes.any,
  propertiesPageNode: React.PropTypes.any,
  searchProperties: React.PropTypes.func.isRequired,
  viewer: React.PropTypes.object,
  hasSearched: React.PropTypes.bool.isRequired,
};

export default R.compose(
  connect(
    state => ({
      viewer: state.users.viewer,
      hasSearched: state.properties.hasSearched,
    }),
    { searchProperties },
  ),
)(PropertiesSearch);



// WEBPACK FOOTER //
// ./src/browser/propertiesSearch/PropertiesSearch.js